import React, { useMemo, useState } from 'react';
import useTranslate from '../../../../../../Hooks/useTranslate';
import { Button, useTheme } from '@mui/material';
import capitalize from '../../../../../../Helpers/StringsFormatting/capitalize';
import {
  Paper,
  Fade,
  Divider,
  Tabs,
  Tab,
  Box,
  Typography,
} from '@mui/material';
import { useAtomValue } from 'jotai';
import { userBranchesAtom } from '../../../../../../Atoms';
import Header from '../../../../../../Components/ContactListWrapper/EntriesWrapper/Header';
import {
  CenteredFlexBox,
  ColumnFlexBox,
} from '../../../../../../Components/FlexBox';
import HorizontalStackedLineChart from '../../../../../../Components/Charts/HorizontalStackedLineChart';
import GraphsLegend from '../../../../../../Components/Charts/GraphsLegend';
import BackButton from '../../../BackButton';
import TooltipContent from './Components/TooltipContent';
import SummariesChart from './Components/SummariesChart';
import ConfirmDialog from '../../../../../../Components/Dialog/ConfirmDialog';
import OverlapsPage from '../OverlapsPage';

const SimulationSummaries = function SimulationSummaries({
  data,
  summaries = [],
  show = false,
  close = () => {},
  tabs = [],
  branchId = null,
  onClickChangeFilters = () => {},
  reloadSummaries = () => {},
  handleConfirmFilters = () => {},
}) {
  const theme = useTheme();
  const translate = useTranslate();
  const userBranches = useAtomValue(userBranchesAtom);

  const [overlapsPage, setOverlapsPage] = useState(null);
  const [confirmDialog, setConfirmDialog] = useState(false);
  // Determine if we are in light or dark mode to pick the right color shade

  const handleConfirmClick = () => {
    if (!data?.overlapSummaries || data.overlapSummaries.length === 0) {
      setConfirmDialog(true);
      return;
    }
    setOverlapsPage(data?.overlapSummaries);
  };

  const handleCloseConfirmDialog = () => {
    setConfirmDialog(false);
  };

  return (
    <>
      <ConfirmDialog
        open={confirmDialog}
        onCancel={handleCloseConfirmDialog}
        onSubmit={() =>
          handleConfirmFilters(data?.id, () => {
            handleCloseConfirmDialog();
            close();
          })
        }
        title="CONFIRM_SIMULATION"
        question="CONFIRM_SIMULATION_QUESTION"
        fontSize="1.5rem"
      />
      <OverlapsPage
        show={Boolean(overlapsPage)}
        overlapSummaries={overlapsPage}
        sections={tabs}
        close={() => setOverlapsPage(null)}
        reloadSummaries={() => reloadSummaries({ id: data?.id })}
      />
      <Fade in={show && !overlapsPage} unmountOnExit>
        <Paper
          sx={{
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            padding: '8px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Header
            hideSearchBar
            hideSorting
            hideFilters
            hideExportExcel
            title={`${translate('SIMULATION_SUMMARIES')} - ${capitalize(userBranches?.find(({ id }) => id === branchId)?.branchDescription || '')}`}
            caption={
              <BackButton onClick={close} label={'SIMULATIONS_HISTORY'} />
            }
          />
          <Divider />
          <ColumnFlexBox overflow="auto" width="100%" height="100%">
            <SummariesChart summaries={summaries} tabs={tabs} />
            <Divider />
            <CenteredFlexBox
              padding="16px"
              gap="16px"
              justifyContent="flex-end"
            >
              <Button
                id="change-filters"
                variant="outlined"
                onClick={() => onClickChangeFilters(data)}
                size="large"
              >
                {translate('CHANGE_FILTERS')}
              </Button>
              <Button
                id="confirm"
                variant="contained"
                onClick={handleConfirmClick}
                size="large"
              >
                {data?.overlapSummaries?.length === 0? translate('COMMIT_SIMULATION') : translate('CONFIRM_FILTERS')}
              </Button>
            </CenteredFlexBox>
          </ColumnFlexBox>
        </Paper>
      </Fade>
    </>
  );
};

export default SimulationSummaries;
